import React from 'react';
import RemoveAllFromBlackList from '../RemoveAllFromBlackList';
import useTranslation from 'hooks/useTranslation';
import { QuestionMark } from 'assets/icons';
import { HeaderSectionIcon } from 'components';

const BlackListHeader = () => {
  const { getTranslation } = useTranslation('BLACKLIST');
  const { t } = getTranslation();

  return (
    <div className='blacklist__header flex flex-jc-sb flex-wrap'>
      <div className='blacklist__header__title flex flex-colgap-8'>
        <HeaderSectionIcon />

        <div>
          <h1 className='main_section_header_title'> {t('HEADING_TITLE')} </h1>
          <p className='blacklist__header__title__subtext main_section_header_desc'>
            {t('HEADING_SUBTITLE')}
          </p>
        </div>
      </div>

      <div className='flex flex-ai-c' style={{ columnGap: '16px' }}>
        <a
          className='flex flex-ai-c main_section_header_moreInfo'
          href='https://help.raychat.io/article/black-list'
          target='blank'
          style={{ columnGap: '4px' }}
        >
          <img src={QuestionMark} alt='Question Mark' />
          {t('MORE_INFO')}
        </a>

        <RemoveAllFromBlackList title={t('DELETE_ALL_FROM_BLACK_LIST')} />
      </div>
    </div>
  );
};

export default BlackListHeader;
